import React, { Component } from 'react';

import { Form, InputGroup, Button,  OverlayTrigger, Tooltip } from 'react-bootstrap';

import * as util from '../../library/utilitys';
class CommonInput extends Component{

    constructor(props) {
        super(props);
        this.state = {
            showPassword: false,
            changePassword: false,
        };
    }

    toggleShowPassword = () => {
        this.setState(prevState => ({
            showPassword: !prevState.showPassword
        }));
    };

    toggleChangePassword = () => {
        this.setState(prevState => ({
            changePassword: !prevState.changePassword
        }));
    };

    render = () => {

        let props = this.props;

        let { type, rows, id, label, value, placeholder, validator, error} = props?.input;

        let { mode, element, callback , disabled = false, hr = false, floatingLabel = true, size = "md", onGeneratePassword, toggleChangePassword } = props;

        const safeValue = (value === null || value === 'null') ? '' : value;
        const formattedValue = validator?.type === "number" ? util.formatNumber(safeValue) : safeValue;
        
        const isPassword = type === "password";
        const inputType = isPassword ? (this.state.showPassword ? "text" : "password") : type;
        
        const formControlClass = `form-control ${error?.status === true ? "is-invalid" : error?.status === false ? "is-valid" : ""}`;

        return (
            <>
                {element === 'Inputs' && floatingLabel === true && (
                    <div className="mb-0">
                        <Form.Label className={size === 'sm' ? 'label-size-sm' : ''}>
                            {label}{' '}
                            {validator.required && (
                                <i
                                className="fa-classic fa-light fa-asterisk fa-fw"
                                style={{
                                    fontSize: '0.5rem',
                                    verticalAlign: 'text-top'
                                }}
                                />
                            )}
                        </Form.Label>
                    </div>
                )}

                {isPassword ? (
                    <InputGroup>
                        <Form.Control
                            type={inputType}
                            id={id}
                            name={`${element}_${id}`}
                            value={formattedValue}
                            placeholder={placeholder || label}
                            className={formControlClass}
                            onChange={(e) => callback(e, element)}
                            disabled={disabled}
                            autoComplete="off"
                            size={size}
                        />
                            {mode === 'new' && (
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="tooltip-password-toggle">{this.state.showPassword ? 'แสดง' : 'ซ่อนรหัสผ่าน'}</Tooltip>}
                                >
                                    <Button
                                        size="sm"
                                        variant="dark"
                                        onClick={(e) => this.toggleShowPassword(e)}
                                        tabIndex={-1}
                                    >
                                        {this.state.showPassword ? <i className="fa-classic fa-light fa-eye fa-fw"></i> : <i className="fa-classic fa-light fa-eye-slash fa-fw"></i> }
                                    </Button>
                                </OverlayTrigger>
                            )}

                            {mode === 'new' && (
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="tooltip-password-toggle">สร้างรหัสผ่าน</Tooltip>}
                                >
                                <Button
                                        size="sm"
                                        variant="primary"
                                        onClick={(e) => onGeneratePassword(e, element)}
                                        tabIndex={-1}
                                        >
                                        <i className="fa-classic fa-light fa-wand-magic-sparkles fa-fw me-1"></i>
                                    </Button>
                                </OverlayTrigger>
                            )}


                            {mode === 'update' && (
                                <>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip id="tooltip-password-toggle">เปลี่ยนรหัสผ่าน</Tooltip>}
                                    >
                                    <Button
                                            size="sm"
                                            variant={this.state.changePassword ? 'primary' : 'secondary'}
                                            onClick={(e) => {
                                                this.toggleChangePassword();
                                                toggleChangePassword();
                                            }}
                                            tabIndex={-1}
                                            >
                                            <i className="fa-classic fa-light fa-arrows-rotate fa-fw me-1"></i>
                                        </Button>
                                    </OverlayTrigger>
                                </>
                            )}
                    </InputGroup>
                ) : (
                    <Form.Control
                        as={type === "text" ? "input" : type === "textarea" ? "textarea" : undefined}
                        type={["text", "textarea"].includes(type) ? type : undefined}
                        rows={type === "textarea" ? rows : undefined}
                        id={id}
                        name={`${element}_${id}`}
                        value={formattedValue}
                        placeholder={placeholder || label}
                        className={formControlClass}
                        onChange={(e) => callback(e, element)}
                        disabled={disabled}
                        size={size}
                    />
                )}

                {(element === 'Inputs' && error?.status) && (
                    <Form.Control.Feedback type="invalid" className="mt-2 ms-2" style={{fontSize: '0.75rem'}}>
                        <i className="fa-classic fa-light fa-circle-exclamation fa-fw me-1" />
                        {error?.msg}
                    </Form.Control.Feedback> 
                )}

                {hr && (<hr className="hr-custom" />)}
            </>

        )
    }
}

export default CommonInput;